import { SlotRepository } from '../Repositories/SlotRepository';
import { CreateSlotDTO, Slot } from '../../Model/Slot';
import { User } from '../../../User/Model/User';
import { assertAdminOrManager } from './Utils/Permission';
import { isSlotOperationRestricted, getRestrictionMessage } from './Utils/TimeRestriction';

export interface BatchCreateSlotRequest {
  count: number;
  slots: CreateSlotDTO[];
}

export class BatchCreateSlotUseCase {
  constructor(private repo: SlotRepository) {}

  async execute(request: BatchCreateSlotRequest, me: User): Promise<Slot[]> {
    /* ── 시간 제한 체크 ─────────────────────────── */
    if (isSlotOperationRestricted(me)) {
      throw new Error(getRestrictionMessage('생성', me));
    }

    /* ── 권한 체크 ─────────────────────────────── */
    assertAdminOrManager(me);

    return this.repo.batchCreate(request);
  }
} 